import { WA_BLACK, WA_TRANSPARANT } from '@constants';

export const FORM_SINGLE_FIELD = {
  QUESTION: {
    name: 'question',
    label: 'Question:',
    placeholder: 'Enter a question',
    rules: [{ required: true, message: 'Title is required' }],
  },
  RESPONSE: {
    name: 'response',
    label: 'Response:',
    placeholder: 'Enter a response',
    rules: [{ required: true, message: 'Response is required' }],
  },
};

export const FORM_SINGLE_FIELD_EDITED = {
  QUESTION: {
    name: 'questionEdited',
    label: 'Question:',
    placeholder: 'Enter a question',
    rules: [{ required: true, message: 'Title is required' }],
  },
  RESPONSE: {
    name: 'responseEdited',
    label: 'Response:',
    placeholder: 'Enter a response',
    rules: [{ required: true, message: 'Response is required' }],
  },
};

export const FORM_FIELD = {
  TITLE: {
    name: 'title',
    label: 'Title:',
    placeholder: 'Enter a title',
    rules: [{ required: true, message: 'Title is required' }],
  },
  DESCRIPTION: {
    name: 'description',
    label: 'Description:',
    placeholder: 'Enter a description',
    rules: [{ required: true, message: 'Description is required' }],
  },
  URL: {
    name: 'url',
    label: 'URL:',
    placeholder: 'Enter the page URL',
    rules: [
      { required: true, message: 'URL is required' },
      { type: 'url', message: "Doesn't look like a valid URL" },
    ],
  },
  URL_TEXT: {
    name: 'urlText',
    label: 'URL Text:',
    placeholder: 'Enter the text that redirects to URL',
    rules: [{ required: true, message: 'URL text is required' }],
  },
  BACKGROUND_COLOUR: {
    name: 'backgroundColour',
    label: 'Background colour:',
    colors: [WA_BLACK, WA_TRANSPARANT],
    rules: [{ required: true, message: 'Background colour is required' }],
  },
  QUESTIONS: {
    name: 'questions',
  },
};

export const INITIAL_VALUES = {
  [FORM_FIELD.TITLE.name]: '',
  [FORM_FIELD.DESCRIPTION.name]: '',
  [FORM_FIELD.URL.name]: '',
  [FORM_FIELD.URL_TEXT.name]: '',
  [FORM_FIELD.BACKGROUND_COLOUR.name]: '',
  [FORM_FIELD.QUESTIONS.name]: [],
};

export const FORM_FIELDS = Object.values(FORM_FIELD);
